import React from "react";
import "./TableData.css";

import { Typography } from "@mui/material";
import { costOfDebt } from "../content";

const CostOfDebt = () => {
  // console.log(costData);
  return (
    <>
      <div className="cost_of_debt pt-md-3">
        <Typography
          variant="h5"
          style={{
            fontFamily: "'Archivo', sans-serif",
            fontWeight: 700,
            color: "#1F1F1F",
          }}
        >
          {costOfDebt[0].heading}
        </Typography>
        <p className="subOne font-size pt-3">{costOfDebt[0].paraOne}</p>
        <p className="subTwon font-size">{costOfDebt[0].paraTwo}</p>
        <p className="subThree font-size">{costOfDebt[0].paraThree}</p>

        <div id="key_list">
          <ul
            style={{
              listStyle: "disc",
              fontSize: 16,
              color: "#1f1f1f",
              lineHeight: "24px",
            }}
            className=" archivo mt-3"
          >
            {costOfDebt[0].infoList &&
              costOfDebt[0].infoList.map((item, index) => (
                <li key={index}>
                  <strong>{item.info}</strong>
                  {item.description}
                </li>
              ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default CostOfDebt;
